import React from "react";
import * as Mui from "@mui/material";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { IntegrationType } from "type/integration-type";
import * as Icons from "react-feather";
import { settingsEmailRouting } from "routes/paths";
import { getUser } from "redux/selector";
import { copyFor, isWhiteLabel } from "../../follow-up-boss-copy";

const mapStateToProps = (state: RootState) => ({
    user: getUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    saveIntegration,
}, dispatch);

interface Props extends
    ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps>
{
    integrationType: IntegrationType;
    onClose: Function;
    onFubConnect?: (id: number) => void;
}

interface State {
    saving: boolean;
}

class Component extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = { saving: false };
    }

    private async handleConnect() {
        const { integrationType, saveIntegration, onClose, onFubConnect } = this.props;
        this.setState({ saving: true });
        try {
            const result = await saveIntegration({ integration: { integrationType, data: {} } }) as any;
            const newId: number = result?.payload?.id;
            if (onFubConnect && newId) {
                onFubConnect(newId);
            } else {
                onClose();
            }
        } catch(_e) {
            this.setState({ saving: false });
            onClose();
        }
    }

    public render() {
        const { saving } = this.state;
        const { user } = this.props;
        const copy = copyFor(user);
        return (
            <Mui.Grid container direction="column" spacing={2}>
                <Mui.Grid item>
                    <Mui.Typography variant="body2">
                        {copy.addCardBlurb}
                    </Mui.Typography>
                </Mui.Grid>
                {/* MAX-4580: the Learn More article is on the iHomefinder knowledge base, so it
                    is not offered to a reseller's customer */}
                {!isWhiteLabel(user) && (
                    <Mui.Grid item>
                        <Mui.Link
                            href="https://kb.ihomefinder.com/s/article/fub-integration"
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="body2"
                            style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
                        >
                            Learn More <Icons.ExternalLink size={16} />
                        </Mui.Link>
                    </Mui.Grid>
                )}
                <Mui.Grid item>
                    {/* Design-system warning banner (Figma Banner/Warning): 16px padding,
                        icon aligned through the title's line, title and description on
                        separate lines in text-primary */}
                    <Mui.Box style={{ backgroundColor: "#FFF9E0", borderRadius: 4, padding: 16 }}>
                        <Mui.Box display="flex" style={{ gap: 8 }}>
                            <Icons.AlertTriangle size={16} style={{ color: "#9D6506", flexShrink: 0, marginTop: 4 }} />
                            <Mui.Box>
                                <Mui.Typography style={{ fontSize: 16, lineHeight: "24px", fontWeight: 700, color: "#1C1B1F" }}>
                                    Using Zapier or another platform to forward leads to Follow Up Boss?
                                </Mui.Typography>
                                <Mui.Typography style={{ fontSize: 16, lineHeight: "24px", color: "#1C1B1F", marginTop: 4 }}>
                                    To avoid duplicate leads, turn off lead forwarding in Zapier or your other platform before connecting — including any forwarding emails added under{" "}
                                    <Mui.Link
                                        href={settingsEmailRouting}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#36747B", textDecoration: "underline" }}
                                    >
                                        Advanced Routing <Icons.ExternalLink size={16} style={{ verticalAlign: "text-bottom", marginLeft: 2 }} />
                                    </Mui.Link>
                                </Mui.Typography>
                            </Mui.Box>
                        </Mui.Box>
                    </Mui.Box>
                </Mui.Grid>
                <Mui.Grid item>
                    <Mui.Button
                        variant="contained"
                        color="primary"
                        disabled={saving}
                        onClick={() => this.handleConnect()}
                    >
                        {saving ? <Mui.CircularProgress size={18} /> : "Connect"}
                    </Mui.Button>
                </Mui.Grid>
            </Mui.Grid>
        );
    }
}

export const FollowUpBossIntegration = connect(mapStateToProps, mapDispatchToProps)(Component);
